import importantCarousel from './nyan.js';
import { initGsapAnimations, initPageAnimations } from './gsap.js';

window.addEventListener('load', init);


function init(e) {

  /*==MENU ACESSIBILIDADE==*/
  var btA11y = document.querySelector('#a11y .a11y__btn');
  var wrapperA11y = document.getElementById('a11y');
  var btFecharA11y = document.querySelector('#a11y .a11y__close');

  if (wrapperA11y && btA11y) btA11y.addEventListener('click', abrirA11y);
  if (wrapperA11y && btFecharA11y) btFecharA11y.addEventListener('click', fecharA11y);

  function abrirA11y() {
    wrapperA11y.classList.add('active');
  }

  function fecharA11y() {
    wrapperA11y.classList.remove('active');
  }

  sessionStorage.getItem('contrast') && +sessionStorage.getItem('contrast') && document.body.classList.add('has--high-contrast');

  if (document.querySelector('[data-contrast]')) {
    document.querySelector('[data-contrast]').addEventListener(
      'click',
      () => {
        document.body.classList.toggle('has--high-contrast');

        sessionStorage.setItem('contrast', document.body.classList.contains('has--high-contrast') ? 1 : 0);
      },
      true
    );
  }

  const rootElement = document.documentElement;

  // Seleciona os botões uma única vez
  const decreaseButton = document.querySelector('[data-fontsize-decrease]');
  const increaseButton = document.querySelector('[data-fontsize-increase]');

  // --- CONFIGURAÇÕES ---
  const minSize = 8; // Tamanho mínimo em pixels
  const maxSize = 12; // Tamanho máximo em pixels
  const step = 1;     // Quanto aumentar/diminuir a cada clique

  /**
   * Aplica o novo tamanho da fonte e salva na sessão.
   * @param {number} size - O novo tamanho da fonte em pixels.
   */
  const applyFontSize = (size) => {
    rootElement.style.fontSize = `${size}px`;
    sessionStorage.setItem('fontsize', size);
  };

  // Ao carregar a página, verifica se há um tamanho salvo na sessão
  const savedSize = sessionStorage.getItem('fontsize');
  if (savedSize) {
    applyFontSize(parseInt(savedSize));
  }

  // Evento para o botão de diminuir a fonte
  if (decreaseButton) {
    decreaseButton.addEventListener('click', (event) => {
      event.preventDefault();
      // Pega o tamanho da fonte atual computado do elemento <html>
      const currentSize = parseInt(window.getComputedStyle(rootElement).fontSize);

      if (currentSize > minSize) {
        applyFontSize(currentSize - step);
      }
    });
  }

  // Evento para o botão de aumentar a fonte
  if (increaseButton) {
    increaseButton.addEventListener('click', (event) => {
      event.preventDefault();
      const currentSize = parseInt(window.getComputedStyle(rootElement).fontSize);

      if (currentSize < maxSize) {
        applyFontSize(currentSize + step);
      }
    });
  }
}

/*==animação big numbers==*/
var bigNumbers = document.querySelectorAll('[data-countup-number]');

if (bigNumbers) {

  class countUp {
    constructor(el) {
      this.el = el;
      this.setVars();
      this.init();
    }

    setVars() {
      this.number = this.el.querySelectorAll('[data-countup-number]');
      this.observerOptions = { root: null, rootMargin: '0px 0px', threshold: 0 };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const end = parseFloat(entry.target.dataset.countupNumber.replace(/,/g, ''));
          const decimals = this.countDecimals(end);
          if (entry.isIntersecting) {
            this.iterateValue(entry.target, end, decimals);
          }
        });
      }, this.observerOptions);
    }

    init() {
      if (this.number.length > 0) {
        this.number.forEach(el => {
          this.observer.observe(el);
        });
      }
    }

    iterateValue(el, end, decimals) {
      const start = 0;
      const duration = 1500;
      let startTimestamp = null;

      const step = timestamp => {
        if (!startTimestamp) startTimestamp = timestamp;
        const elapsedPercent = (timestamp - startTimestamp) / duration;
        const easedProgress = Math.min(this.easeOutQuint(elapsedPercent), 1);
        let interimNumber = Math.abs(easedProgress * (end - start) + start);
        el.innerHTML = this.formatNumber(interimNumber, decimals);
        if (easedProgress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      // requestAnimationFrame returns DOMHighResTimeStamp as a callback (used as timestamp)
      window.requestAnimationFrame(step);
    }

    easeOutQuad(x) {
      return 1 - Math.pow(1 - x, 3);
    }

    easeOutQuint(x) {
      return 1 - Math.pow(1 - x, 5);
    }

    countDecimals(val) {
      if (Math.floor(val) === val) return 0;
      return val.toString().split('.')[1].length || 0;
    }

    formatNumber(val, decimals) {
      return val.toLocaleString('pt-br', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }
  }

  // Simplifed version of Viget dynamic modules to attach instances for this demo
  // https://www.viget.com/articles/how-does-viget-javascript/
  // You CAN use this pattern, but it's single purpose right now
  const dataModules = [...document.querySelectorAll('[data-module="countup"]')];

  dataModules.forEach(element => {
    element.dataset.module.split(' ').forEach(function () {
      new countUp(element);
    });
  });
}

//BT COPIAR POSTS
function copiarLink() {
  const textoCopiado = btCopiar.getAttribute('data-copy')
  const toastCopiado = document.getElementById('toast-copiado')
  console.log(toastCopiado)
  navigator.clipboard.writeText(textoCopiado)
  toastCopiado.className = 'active'
  setTimeout(() => { toastCopiado.className = toastCopiado.className.replace('active', '') }, 2400)
}

var btCopiar = document.querySelector('#bt-copy')

if (btCopiar) {
  btCopiar.addEventListener('click', copiarLink)
}

/*==COOKIES==*/
(function () {
  'use strict';

  var cookieAlert = document.getElementById('cookiealert');
  var acceptCookies = document.getElementById('acceptcookies');

  if (!cookieAlert) {
    return;
  }

  cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

  // Show the alert if we cant find the "acceptCookies" cookie
  if (!getCookie('acceptCookies')) {
    cookieAlert.classList.add('show');
  }

  // When clicking on the agree button, create a 1 year
  // cookie to remember user's choice and close the banner
  acceptCookies.addEventListener('click', function () {
    setCookie('acceptCookies', true, 365);
    cookieAlert.classList.remove('show');
  });

  // Cookie functions from w3schools
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
})();

document.addEventListener('DOMContentLoaded', function () {

  new importantCarousel();
  initGsapAnimations();
  initEspecialidadesMobile();
  initFloatingLabels();
  initAutoGrowTextareas();
  initPhoneMasks();
  initSubmitButtonAnimation();
  initLazyLoadVideos();
  initMouseHoverFillButtons();
  initSearchOverlay();
  initPrivacyTOC();
  initResponsiveBackgrounds();
  initConditionalSubmit();
  initFormTabs();
  initDesktopDragScroll();
  initFilterModalLogic();
  initAbasClientes();
  initChangeCasesListStyle();
  initModalEspecialidadesHome();
  initLanguageDropdown();

  // SLIDERS 
  initCaseSliders();
  initSpecialtyPills();
  initHomeSpecialtiesSlider();
  initSobreSliders();
  initDragToScroll();
  initSobreCertificacoesSlider();
  initBlogSliders();
  initModalEspecialidadesHomeSlider();
  initLazyVideos();
  initSliderInternacional();
  initCardsInternacional();
  initProjetosInternacional();
  // initClientesInternacional();
  initBrasilInternacional();


  const menuButton = document.querySelector('.menu-button');
  const mainMenu = document.querySelector('#main-menu');
  const closeButton = document.querySelector('.close');
  function updateMenuState() {
    const isMenuOpen = mainMenu.classList.contains('is-active');
    menuButton.setAttribute('aria-expanded', isMenuOpen);
  }

  if (menuButton && mainMenu && closeButton) {

    menuButton.addEventListener('click', function () {
      mainMenu.classList.toggle('is-active');
      updateMenuState();
    });

    closeButton.addEventListener('click', function () {
      mainMenu.classList.remove('is-active');
      updateMenuState();
    });
  }

  const casesSwiper = new Swiper('.cases-swiper-container', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,

    updateOnImagesReady: true,

    observer: true,
    observeParents: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const animationSpeed = 200;
  const minDuration = .6;
  const maxDuration = .7;

  const accordions = gsap.utils.toArray('.accordions details');

  accordions.forEach((detailsEl, index) => {
    const summaryEl = detailsEl.querySelector('summary');
    const contentEl = detailsEl.querySelector('.faq-content');

    if (!summaryEl || !contentEl) return;


    summaryEl.addEventListener('click', (event) => {
      event.preventDefault();

      accordions.forEach(otherDetails => {
        if (otherDetails !== detailsEl && otherDetails.open) {
          const otherContent = otherDetails.querySelector('.faq-content');
          const height = otherContent.offsetHeight;
          const duration = Math.min(maxDuration, Math.max(minDuration, height / animationSpeed));

          gsap.to(otherContent, {
            height: 0,
            opacity: 0,
            duration: duration,
            ease: 'power1.inOut',
            onComplete: () => otherDetails.removeAttribute('open')
          });
        }
      });

      if (detailsEl.open) {
        const height = contentEl.offsetHeight;
        const duration = Math.min(maxDuration, Math.max(minDuration, height / animationSpeed));

        gsap.to(contentEl, {
          height: 0,
          opacity: 0,
          duration: duration,
          ease: 'power1.in',
          onComplete: () => detailsEl.removeAttribute('open')
        });
      } else {
        detailsEl.setAttribute('open', true);
        const height = contentEl.offsetHeight;
        const duration = Math.min(maxDuration, Math.max(minDuration, height / animationSpeed));

        gsap.fromTo(contentEl,
          { height: 0, opacity: 0 },
          {
            height: 'auto',
            opacity: 1,
            duration: duration,
            ease: 'power1.inOut'
          }
        );
      }
    });
  });

  const pillSliders = document.querySelectorAll('[data-swiper="pilula"]');

  if (pillSliders.length > 0) {
    pillSliders.forEach(sliderEl => {
      new Swiper(sliderEl, {
        slidesPerView: 'auto',
        freeMode: true,
        grabCursor: true,
        spaceBetween: 10,
        mousewheel: {
          forceToAxis: true,
        },
      });
    });
  };

  const facade = document.querySelector('.case__video-facade');
  if (facade) {
    facade.addEventListener('click', function () {
      const videoSrc = this.dataset.videoSrc;
      if (!videoSrc) {
        return;
      }

      const videoPlayer = document.createElement('video');
      videoPlayer.src = videoSrc;
      videoPlayer.controls = true;
      videoPlayer.autoplay = true;
      videoPlayer.width = this.offsetWidth;
      videoPlayer.height = this.offsetHeight;

      this.innerHTML = '';
      this.appendChild(videoPlayer);
    }, { once: true });
  };

  const videoSliders = document.querySelectorAll('[data-swiper="case-videos"]');

  if (videoSliders.length > 0) {

    const desktopBreakpoint = window.matchMedia('(min-width: 992px)');

    let swiperInstances = new Map();

    const initSwiper = (sliderEl) => {
      if (swiperInstances.has(sliderEl)) return;

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1.1,
        spaceBetween: 20,
        loop: false,
        grabCursor: true,
        freeMode: true,
        on: {
          init: function () {
            const activeSlide = this.slides[this.activeIndex];
            const video = activeSlide.querySelector('video.lazy-video');
            if (video) {
              if (!video.src && video.dataset.src) {
                video.src = video.dataset.src;
              }
              video.play().catch(() => { });
            }
          },
          slideChangeTransitionEnd: function () {
            this.slides.forEach(slide => {
              const video = slide.querySelector('video.lazy-video');
              if (video) video.pause();
            });

            const activeSlide = this.slides[this.activeIndex];
            const video = activeSlide.querySelector('video.lazy-video');
            if (video) {
              if (!video.src && video.dataset.src) {
                video.src = video.dataset.src;
              }
              video.play().catch(() => { });
            }
          },
        },
      });
      swiperInstances.set(sliderEl, swiper);
    };

    const initIntersectionObserver = (sliderEl) => {
      if (swiperInstances.has(sliderEl)) {
        swiperInstances.get(sliderEl).destroy(true, true);
        swiperInstances.delete(sliderEl);
      }

      const lazyVideos = sliderEl.querySelectorAll('video.lazy-video[data-src]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (lazyVideos.length === 0 || prefersReducedMotion) return;

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (!video.src) {
              video.src = video.dataset.src;
            }
            video.play().catch(() => { });
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });

      lazyVideos.forEach(video => videoObserver.observe(video));
    };

    const handleBreakpointChange = (event) => {
      videoSliders.forEach(sliderEl => {
        if (event.matches) {
          initIntersectionObserver(sliderEl);
        } else {
          initSwiper(sliderEl);
        }
      });
    };

    handleBreakpointChange(desktopBreakpoint);

    desktopBreakpoint.addEventListener('change', handleBreakpointChange);
  };

});

function initSearchOverlay() {
  const searchToggleButton = document.querySelector('.search-button');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchCloseButton = searchOverlay ? searchOverlay.querySelector('.search-overlay__close') : null;
  const searchInput = searchOverlay ? searchOverlay.querySelector('.search-form__field') : null;

  if (!searchToggleButton || !searchOverlay || !searchInput) {
    return;
  }

  const openSearch = () => {
    searchOverlay.classList.add('is-active');
    searchToggleButton.classList.add('is-active');
    setTimeout(() => searchInput.focus(), 300);
  };

  const closeSearch = () => {
    document.body.classList.remove('search-is-active');
    searchToggleButton.classList.remove('is-active');
    searchOverlay.classList.remove('is-active');
    document.body.style.paddingRight = '';
  };

  searchToggleButton.addEventListener('click', () => {
    const isActive = searchOverlay.classList.contains('is-active');

    if (isActive) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  if (searchCloseButton) {
    searchCloseButton.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
      closeSearch();
    }
  });
}

function initMouseHoverFillButtons() {
  const animatedButtons = document.querySelectorAll('[data-mouse-hover-fill]');

  if (!animatedButtons.length) {
    return;
  }

  animatedButtons.forEach(button => {
    button.addEventListener('mouseenter', (e) => {
      const rect = button.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      button.style.setProperty('--x', `${x}px`);
      button.style.setProperty('--y', `${y}px`);
    });
  });
}

function initSpecialtyPills() {
  const sliderEl = document.querySelector('[data-swiper="specialty-pills"]');
  if (!sliderEl) return;

  new Swiper(sliderEl, {
    slidesPerView: 'auto',
    freeMode: true,
    grabCursor: true,
    spaceBetween: 10,
  });
}

function initModalEspecialidadesHomeSlider() {
  const sliders = document.querySelectorAll('[data-swiper="especialidades-home"]');

  sliders.forEach(slider => {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: slider.parentElement.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
          allowTouchMove: false,
          pagination: {
            enabled: false
          }
        }
      }
    });
  });
}

function initCaseSliders() {
  const sliders = document.querySelectorAll('[data-swiper="cases-slider"]');

  if (sliders.length === 0) return;

  sliders.forEach(sliderEl => {
    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,

      pagination: {
        el: '.cases-slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.cases-slider__nav-button--next',
        prevEl: '.cases-slider__nav-button--prev',
      },

      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3,
        }
      }
    });
  });
}

function initFloatingLabels() {
  const formFields = document.querySelectorAll('.wpforms-field:not(.wpforms-field-checkbox, .wpforms-field-radio, .wpforms-field-submit) input, .wpforms-field-textarea textarea');

  formFields.forEach(field => {
    const parentWrapper = field.closest('.wpforms-field');
    if (!parentWrapper) return;

    const updateFilledState = () => {
      if (field.value) {
        parentWrapper.classList.add('is-filled');
      } else {
        parentWrapper.classList.remove('is-filled');
      }
    };

    field.addEventListener('focus', () => {
      parentWrapper.classList.add('is-focused');
    });

    field.addEventListener('blur', () => {
      parentWrapper.classList.remove('is-focused');
    });

    field.addEventListener('input', updateFilledState);

    updateFilledState();
  });
}

function initAutoGrowTextareas() {
  const textareas = document.querySelectorAll('.wpforms-field-textarea textarea');
  textareas.forEach(textarea => {
    const adjustHeight = () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    };

    textarea.addEventListener('input', adjustHeight);
    adjustHeight();
  });
}

function initSubmitButtonAnimation() {
  const forms = document.querySelectorAll('.contato__form .wpforms-form, .case__form .wpforms-form');

  if (forms.length === 0) return;

  forms.forEach(form => {
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    form.addEventListener('submit', () => {
      submitButton.classList.add('is-sending');

      submitButton.textContent = 'ENVIANDO';
      submitButton.disabled = true;

      let dotCount = 0;
      const originalText = 'ENVIANDO';
      const interval = setInterval(() => {
        dotCount = (dotCount + 1) % 4;
        submitButton.textContent = originalText + '.'.repeat(dotCount);
      }, 250);
    });
  });
}

function initConditionalSubmit() {
  const forms = document.querySelectorAll('.wpforms-form');

  if (forms.length === 0) return;

  forms.forEach(form => {
    const requiredFields = form.querySelectorAll('.wpforms-field-required input, .wpforms-field-required textarea');
    const submitButton = form.querySelector('.wpforms-submit');

    if (!submitButton || requiredFields.length === 0) return;

    submitButton.disabled = true;

    const checkValidation = () => {
      let allFieldsValid = true;
      requiredFields.forEach(field => {
        if (field.type === 'checkbox') {
          if (!field.checked) {
            allFieldsValid = false;
          }
        }
        else {
          if (field.value.trim() === '') {
            allFieldsValid = false;
          }
        }
      });

      submitButton.disabled = !allFieldsValid;
    };

    requiredFields.forEach(field => {
      field.addEventListener('input', checkValidation);
      field.addEventListener('change', checkValidation);
    });
  });
}

function initPhoneMasks() {
  if (typeof IMask === 'undefined') return;

  const phoneInputs = document.querySelectorAll('.mascara-telefone input');

  phoneInputs.forEach(input => {
    const phoneMask = IMask(input, {
      mask: [
        { mask: '(00) 0000-0000' },
        { mask: '(00) 0 0000-0000' }
      ]
    });
  });
}


document.addEventListener('DOMContentLoaded', function () {
  const homeSwiperEl = document.querySelector('[data-swiper="home-hothome"]');

  if (homeSwiperEl) {
    const progressFill = homeSwiperEl.querySelector('.home-hothome__progress-fill');
    const totalSlides = homeSwiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

    const homeSwiper = new Swiper(homeSwiperEl, {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      noSwipingClass: 'swiper-no-swiping',
      navigation: {
        nextEl: '.home-hothome__nav-button--next',
        prevEl: '.home-hothome__nav-button--prev',
      },
      pagination: {
        el: '.swiper-pagination-fraction',
        type: 'fraction',
      },

      on: {
        init: function () {
          this.emit('slideChange');
        },

        slideChange: function () {
          if (progressFill) {
            const progress = (this.realIndex + 1) / totalSlides;
            progressFill.style.transform = `scaleY(${progress})`;
          }

          const allVideos = this.el.querySelectorAll('.home-hothome__video');
          allVideos.forEach(video => {
            video.pause();
          });

          const activeSlide = this.slides[this.activeIndex];
          const activeVideo = activeSlide.querySelector('.home-hothome__video');

          if (activeVideo) {
            if (!activeVideo.src && activeVideo.dataset.src) {
              activeVideo.src = activeVideo.dataset.src;
            }
            activeVideo.currentTime = 0;
            activeVideo.play().catch(() => {
              console.warn('Autoplay do vídeo bloqueado pelo navegador.');
            });
          }
        }
      },
    });
  }
});


function initLazyLoadVideos() {
  const lazyVideos = document.querySelectorAll('video.lazy-video[data-src]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (lazyVideos.length > 0 && !prefersReducedMotion) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const source = video.querySelector('source');

          source.src = video.dataset.src;

          video.load();

          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.then(_ => {
            })
              .catch(error => {
                console.error("Autoplay bloqueado pelo navegador:", error);
              });
          }

          observer.unobserve(video);
        }
      });
    }, { threshold: 0.1 });

    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  }
}

document.addEventListener('DOMContentLoaded', initLazyLoadVideos);


function initHomeSpecialtiesSlider() {
  const sliderEl = document.querySelector('[data-swiper="home-specialties"]');
  if (!sliderEl) return;

  new Swiper(sliderEl, {
    grabCursor: true,
    navigation: {
      nextEl: '.home-especialidades__controls .swiper-button-next',
      prevEl: '.home-especialidades__controls .swiper-button-prev',
    },
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    effect: 'creative',
    creativeEffect: {
      perspective: true,
      limitProgress: 4,
      prev: {
        translate: ['-105%', '5%', 0],
        rotate: [0, 0, -5],
        origin: 'bottom',
      },
      next: {
        translate: ['105%', '5%', 0],
        rotate: [0, 0, 5],
        origin: 'bottom',
      },
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      }
    }
  });
}

function initPrivacyTOC() {
  var contentPost = document.querySelector('.privacidade-content');

  if (contentPost) {
    var contentPostTitles = contentPost.querySelectorAll('h2');
    var contentIndice = document.querySelector('.privacidade__nav-content');
    for (var elContentPostTitle of contentPostTitles) {
      var indexTtl = Array.from(contentPostTitles).indexOf(elContentPostTitle);
      var idTtl = 'ttl' + indexTtl;
      elContentPostTitle.setAttribute('id', idTtl);
    }

    var contentPostTitles = contentPost.querySelectorAll('h2');
    for (var elContentPostTitle of contentPostTitles) {
      const elItemIndice = document.createElement('a');
      const txtPostTitle = document.createTextNode(elContentPostTitle.textContent);
      var indexTtl = Array.from(contentPostTitles).indexOf(elContentPostTitle);
      var idTtl = 'ttl' + indexTtl;
      var linkPostTitle = '#' + idTtl;
      elItemIndice.setAttribute('href', linkPostTitle);
      elItemIndice.appendChild(txtPostTitle);
      contentIndice.appendChild(elItemIndice);
    }
  }
}

function initSobreSliders() {
  const carousels = document.querySelectorAll('[data-carousel]');

  if (!carousels.length) {
    return;
  }

  carousels.forEach(carousel => {
    const carouselName = carousel.dataset.carousel;
    let config = {};

    const baseConfig = {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      speed: 7500,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
    };

    if (carouselName === 'swiper-sobre-right') {
      config = {
        ...baseConfig,
        loopedSlides: 3,
        autoplay: {
          ...baseConfig.autoplay,
          reverseDirection: false,
        }
      };
    } else if (carouselName === 'swiper-sobre-left') {
      config = {
        ...baseConfig,
        loopedSlides: 4,
        autoplay: {
          ...baseConfig.autoplay,
          reverseDirection: true,
        }
      };
    }

    new Swiper(carousel, config);
  });
}

function initDragToScroll() {
  const tickers = document.querySelectorAll('[data-images-slider]');

  if (!tickers.length) return;

  tickers.forEach(ticker => {
    const list = ticker.querySelector('ul');
    const listItems = Array.from(list.children);
    if (!list) return;

    listItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', true);
      list.appendChild(clone);
    });

    let isPaused = false;
    let isDragging = false;
    let dragStartX = 0;
    let initialScrollPosition = 0;

    const direction = ticker.dataset.direction || 'left';

    const defaultSpeed = 0.5;
    const speedAttribute = ticker.dataset.speed;
    const speed = speedAttribute ? parseFloat(speedAttribute) : defaultSpeed;

    let scrollPosition = direction === 'right' ? -(list.scrollWidth / 2) : 0;

    function animate() {
      if (!isPaused && !isDragging) {
        const halfwayPoint = list.scrollWidth / 2;

        if (direction === 'right') {
          scrollPosition += speed;
          if (scrollPosition >= 0) {
            scrollPosition = -halfwayPoint;
          }
        } else {
          scrollPosition -= speed;
          if (Math.abs(scrollPosition) >= halfwayPoint) {
            scrollPosition = 0;
          }
        }
        list.style.transform = `translateX(${scrollPosition}px)`;
      }
      requestAnimationFrame(animate);
    }

    ticker.addEventListener('mouseenter', () => isPaused = true);
    ticker.addEventListener('mouseleave', () => isPaused = false);

    ticker.addEventListener('mousedown', (e) => {
      isDragging = true;
      ticker.classList.add('is-dragging');
      dragStartX = e.pageX;
      initialScrollPosition = scrollPosition;
      e.preventDefault();
    });

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const dragDelta = e.pageX - dragStartX;
      scrollPosition = initialScrollPosition + dragDelta;

      const maxScroll = 0;
      const minScroll = -(list.scrollWidth / 2);
      if (scrollPosition > maxScroll) scrollPosition = maxScroll;
      if (scrollPosition < minScroll) scrollPosition = minScroll;

      list.style.transform = `translateX(${scrollPosition}px)`;
    };

    const handleMouseUp = () => {
      isDragging = false;
      ticker.classList.remove('is-dragging');
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    animate();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initDragToScroll();
});

function initSobreCertificacoesSlider() {
  const sliderEl = document.querySelector('[data-swiper="swiper-sobre-certificacoes"]');
  if (!sliderEl) return;

  new Swiper(sliderEl, {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      el: '.bloco3 .swiper-pagination',
      clickable: true,
    },
    watchOverflow: true,
    effect: 'slide',
    grabCursor: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 0,
      }
    }
  });
}

function initResponsiveBackgrounds() {
  const elements = document.querySelectorAll('[data-bg-desktop]');
  const wrapperGridAtivo = document.querySelector('.case-listing-grid.active');

  if (elements.length === 0) return;

  const desktopBreakpoint = 992;

  const updateBackgrounds = () => {
    elements.forEach(el => {
      if (window.innerWidth >= desktopBreakpoint && !wrapperGridAtivo) {
        el.style.backgroundImage = `url(${el.dataset.bgDesktop})`;
      } else {
        el.style.backgroundImage = `url(${el.dataset.bgMobile})`;
      }
    });
  };

  updateBackgrounds();
  window.addEventListener('resize', updateBackgrounds);
}

function initFormTabs() {
  const triggers = document.querySelectorAll('[data-form-trigger]');
  const targets = document.querySelectorAll('[data-form-target]');

  if (triggers.length === 0 || targets.length === 0) {
    return;
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      const targetId = this.dataset.formTrigger;

      triggers.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');

      targets.forEach(target => {
        target.classList.remove('is-active');
      });

      const targetToShow = document.querySelector(`[data-form-target="${targetId}"]`);
      if (targetToShow) {
        targetToShow.classList.add('is-active');
      }
    });
  });
}

function initBlogSliders() {
  const galleries = document.querySelectorAll('[data-swiper="post-gallery"]');

  if (galleries.length === 0) return;

  galleries.forEach(galleryEl => {
    new Swiper(galleryEl, {
      loop: true,
      grabCursor: true,
      slidesPerView: 1.2,
      spaceBetween: 30,
      navigation: {
        nextEl: galleryEl.querySelector('.swiper-button-next'),
        prevEl: galleryEl.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        475: {
          slidesPerView: 2.2,
        },
        992: {
          slidesPerView: 3,
        }
      }
    });
  });
}

function initDesktopDragScroll() {
  const slider = document.querySelector('.blog__categorias-wrapper');
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;
  let hasDragged = false;

  const handleMouseDown = (e) => {
    isDown = true;
    hasDragged = false;
    slider.classList.add('is-scrolling');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > 5) { // Threshold para considerar um arraste
      hasDragged = true;
    }

    slider.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    isDown = false;
    slider.classList.remove('is-scrolling');

    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  slider.addEventListener('mousedown', handleMouseDown);

  // Prevenção de clique no link após o arraste (código inalterado)
  const links = slider.querySelectorAll('.blog__categorias-link');
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      if (hasDragged) {
        e.preventDefault();
      }
    });

    link.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  });
}

function initFilterModalLogic() {
  const modal = document.querySelector('#filtros-blog');
  if (!modal) return;

  const categoryButtons = modal.querySelectorAll('.filtros-blog__category-btn');
  const applyButton = modal.querySelector('.filtros-blog__apply-btn');
  const clearButton = modal.querySelector('.filtros-blog__clear-btn');
  const closeButton = modal.querySelector('.filtros-blog__close-btn');
  const openButton = document.querySelector('.blog__categorias-toggle');

  const baseBlogUrl = applyButton.href;
  let selectedSlugs = [];

  const updateButtonsState = () => {
    const hasSelection = selectedSlugs.length > 0;
    applyButton.classList.toggle('is-active', hasSelection);
    clearButton.classList.toggle('is-active', hasSelection);
  };

  const updateApplyButtonUrl = () => {
    if (selectedSlugs.length === 0) {
      applyButton.href = baseBlogUrl;
    } else {
      const queryParams = new URLSearchParams({
        categorias: selectedSlugs.join(',')
      });
      applyButton.href = `${baseBlogUrl}?${queryParams.toString()}`;
    }
  };

  categoryButtons.forEach(button => {
    button.addEventListener('click', () => {
      const slug = button.dataset.slug;
      button.classList.toggle('is-active');

      if (selectedSlugs.includes(slug)) {
        selectedSlugs = selectedSlugs.filter(s => s !== slug);
      } else {
        selectedSlugs.push(slug);
      }
      updateApplyButtonUrl();
      updateButtonsState();
    });
  });

  clearButton.addEventListener('click', () => {
    selectedSlugs = [];
    categoryButtons.forEach(button => button.classList.remove('is-active'));
    updateApplyButtonUrl();
    updateButtonsState();
  });

  const closeFilterModal = () => {
    modal.classList.remove('is-active');
  };

  closeButton.addEventListener('click', closeFilterModal);
  openButton.addEventListener('click', () => modal.classList.add('is-active'));
}

function initAbasClientes() {
  const tabContainer = document.querySelector('.clientes-tab-container');

  if (!tabContainer) {
    return;
  }

  const tabs = tabContainer.querySelectorAll('[role="tab"]');
  const panels = tabContainer.querySelectorAll('[role="tabpanel"]');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      tabs.forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      panels.forEach(panel => {
        panel.classList.remove('is-active');
        panel.setAttribute('hidden', true);
      });

      const targetPanelId = tab.getAttribute('aria-controls');
      const targetPanel = tabContainer.querySelector(`#${targetPanelId}`);

      if (targetPanel) {
        targetPanel.classList.add('is-active');
        targetPanel.removeAttribute('hidden');

        const isMobile = window.innerWidth < 992;

        if (isMobile) {
          const panelTitle = document.querySelector('#scroll-clientes');

          if (panelTitle) {
            const elementPosition = panelTitle.getBoundingClientRect().top;
            const currentScroll = window.scrollY || document.documentElement.scrollTop;
            const offset = 150;
            const targetScrollPosition = elementPosition + currentScroll - offset;

            window.scrollTo({
              top: targetScrollPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    });
  });
}

function initEspecialidadesMobile() {

  const botaoAbrir = document.querySelector('.especialidades-abrir');
  const botaoFechar = document.querySelector('.especialidades-fechar');

  const dropdownEspecialidadesFechar = document.querySelector('.especialidades-fechar');
  const dropdownLinks = document.querySelector('.nav__dropdown-links');
  const dropdownLista = document.querySelector('.especialidades-lista');
  const dropdownEspecialidades = document.querySelector('.especialidades-abrir');

  // Função única que alterna o estado
  const toggleEspecialidades = (event) => {
    event.preventDefault();

    // Alterna a classe 'is-active' em todos os elementos
    dropdownEspecialidadesFechar?.classList.toggle('is-active');
    dropdownLinks?.classList.toggle('is-active');
    dropdownLista?.classList.toggle('is-active');
    dropdownEspecialidades?.classList.toggle('is-active');

    console.log('Estado de especialidades alternado com toggle.');
  };

  // Adiciona o mesmo listener de evento aos dois botões
  if (botaoAbrir) {
    botaoAbrir.addEventListener('click', toggleEspecialidades);
  }
  if (botaoFechar) {
    botaoFechar.addEventListener('click', toggleEspecialidades);
  }
}

function initChangeCasesListStyle() {
  const botaoMudarA = document.querySelector('.tipo-wide');
  const botaoMudarB = document.querySelector('.tipo-boxes');
  const caseListing = document.querySelector('.case-listing-grid');

  // Função única que alterna o estado
  const toggleStyle = (event) => {
    event.preventDefault();

    // Alterna a classe 'active' em todos os elementos 
    caseListing?.classList.toggle('active');
    botaoMudarA?.classList.toggle('active');
    botaoMudarB?.classList.toggle('active');

    initResponsiveBackgrounds();
  };

  // Adiciona o mesmo listener de evento aos dois botões
  if (botaoMudarA) {
    botaoMudarA.addEventListener('click', toggleStyle);
  }
  if (botaoMudarB) {
    botaoMudarB.addEventListener('click', toggleStyle);
  }
}

function initModalEspecialidadesHome() {
  const openButtons = document.querySelectorAll('.js-open-modal');
  const closeButtons = document.querySelectorAll('.js-close-modal');
  const body = document.body;

  if (openButtons.length === 0) return;

  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';

    const closeBtn = modal.querySelector('button.js-close-modal');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
  }

  openButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const modalId = this.getAttribute('data-modal-target');
      openModal(modalId);
    });
  });

  closeButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      const modal = this.closest('.modal-especialidade');
      if (modal) closeModal(modal);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.modal-especialidade.is-active');
      if (activeModal) {
        closeModal(activeModal);
      }
    }
  });
}

function initLanguageDropdown() {
  const wrapper = document.querySelector('.header-languages-wrapper');
  const btn = document.querySelector('.header-languages-current');
  const currentLabel = document.querySelector('.current-label');
  const langLinks = document.querySelectorAll('.custom-lang-switcher .lang-switcher__link');

  if (!wrapper || !btn || !currentLabel) return;

  // 1. Abre/Fecha dropdown ao clicar no botão principal
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    wrapper.classList.toggle('is-open');
    const isExpanded = wrapper.classList.contains('is-open');
    btn.setAttribute('aria-expanded', isExpanded);
  });

  // 2. Fecha o dropdown se o usuário clicar em qualquer outro lugar da tela
  document.addEventListener('click', () => {
    wrapper.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  });

  // 3. Descobre qual é a língua atual com base na URL da página e atualiza o visual
  const currentPath = window.location.pathname;

  langLinks.forEach(link => {
    link.classList.remove('gt-current-lang');

    // Pega o caminho relativo do href do link (ex: /internacional-en/)
    const linkPath = new URL(link.href, window.location.origin).pathname;

    // Verifica se a URL atual bate com o link ou se estamos na home (PT)
    const isCurrentLang = (linkPath === '/' && currentPath === '/') || 
                          (linkPath !== '/' && currentPath.includes(linkPath));

    if (isCurrentLang) {
      // Adiciona a classe que você quer manter pro CSS
      link.classList.add('gt-current-lang');
      
      // Pega o texto do span de dentro do link e joga lá no rótulo do topo
      const langTextSpan = link.querySelector('span');
      if (langTextSpan) {
        currentLabel.textContent = langTextSpan.textContent.trim();
      }
    }
  });
}

function initLazyVideos() {
  const lazyVideos = document.querySelectorAll('video.lazy-video');

  if (lazyVideos.length === 0) return;

  // Opções de otimização: rootMargin carrega o vídeo 200px antes de ele aparecer na tela
  const observerOptions = {
    root: null,
    rootMargin: '200px 0px 200px 0px',
    threshold: 0
  };

  if ('IntersectionObserver' in window) {
    const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // Se o vídeo estiver quase a entrar na tela (margem de 200px) ou já visível
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          const video = entry.target;
          const sources = video.querySelectorAll('source');

          sources.forEach((source) => {
            const src = source.getAttribute('data-src');
            if (src) {
              source.setAttribute('src', src);
            }
          });

          video.load();

          // GATILHO DE SEGURANÇA: Garante que o autoplay vai funcionar após o load
          if (video.hasAttribute('autoplay')) {
            video.play().catch(error => {
              console.log("Autoplay bloqueado pelo browser, aguardando interação.", error);
            });
          }

          video.classList.remove('lazy-video');
          lazyVideoObserver.unobserve(video);
        }
      });
    }, observerOptions);

    lazyVideos.forEach((video) => {
      lazyVideoObserver.observe(video);
    });

  } else {
    // Fallback para segurança total
    window.addEventListener('load', () => {
      lazyVideos.forEach((video) => {
        const sources = video.querySelectorAll('source');
        sources.forEach((source) => {
          const src = source.getAttribute('data-src');
          if (src) {
            source.setAttribute('src', src);
          }
        });
        video.load();
      });
    });
  }
}

//SWIPER INTERNACIONAL
function initSliderInternacional() {
  const sliderInt = document.querySelectorAll('[data-swiper="inter-hothome"]');

  if (sliderInt.length === 0) return;

  sliderInt.forEach(sliderIntEl => {
    new Swiper(sliderIntEl, {
      loop: true,
      grabCursor: false,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: true,
    });
  });
}

function initBrasilInternacional() {
  const CardsBrasilInt = document.querySelectorAll('[data-swiper="inter-brasil"]');

  if (CardsBrasilInt.length === 0) return;

  CardsBrasilInt.forEach(CardsBrasilIntEl => {
    new Swiper(CardsBrasilIntEl, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
        }
      }
    });
  });
}

function initCardsInternacional() {
  const CardsInt = document.querySelectorAll('[data-swiper="inter-house"]');

  if (CardsInt.length === 0) return;

  CardsInt.forEach(CardsIntEl => {
    new Swiper(CardsIntEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 0,
        }
      }
    });
  });
}

function initProjetosInternacional() {
  const ProjetosInt = document.querySelectorAll('[data-swiper="inter-projetos"]');

  if (ProjetosInt.length === 0) return;

  ProjetosInt.forEach(ProjetosIntEl => {
    new Swiper(ProjetosIntEl, {
      slidesPerView: 1,
      navigation: {
        nextEl: '.inter-projetos__nav .swiper-button-next',
        prevEl: '.inter-projetos__nav .swiper-button-prev',
      },
      pagination: {
        el: '.inter-projetos__nav .swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
          },
      },
    });
  });
}

var btnavInt = document.getElementById('btnavInt');
var menuInt = document.getElementById('menuInt');

if (btnavInt) {
  btnavInt.addEventListener('click', abrirNavInt);

  function abrirNavInt() {
    menuInt.classList.toggle('active');
  }
}
